import script from "./AddOrEditDbsCheckModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddOrEditDbsCheckModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddOrEditDbsCheckModal.vue?vue&type=style&index=0&id=d5b23b18&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5b23b18"]])

export default __exports__